var map = {
	"./wastetop_blue.min.png": "8c8f",
	"./wastetop_gray.min.png": "e539",
	"./wastetop_green.min.png": "1bed",
	"./wastetop_orange.min.png": "1848",
	"./wastetop_yellow.min.png": "b806"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6f8";